module.exports = __webpack_public_path__ + "img/newLogo4.015328c3.png";